import { render, staticRenderFns } from "./TextFieldFormatadorDeValor.vue?vue&type=template&id=7bdc2b4e"
import script from "./TextFieldFormatadorDeValor.vue?vue&type=script&lang=js"
export * from "./TextFieldFormatadorDeValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports